/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ privacy_policy: NonNullable<unknown>, terms_of_service: NonNullable<unknown>, "gizlilik_politikası": NonNullable<unknown>, "hizmet_koşulları": NonNullable<unknown> }} Walkturough_Landing_FooterInputs */

const en_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By continuing to use Forest, you agree to our ${i?.privacy_policy} and ${i?.terms_of_service}.`)
};

const ar_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`بمتابعتك لاستخدام Forest، فإنك توافق على ${i?.privacy_policy} و${i?.terms_of_service}.`)
};

const de_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Indem Sie Forest weiterhin nutzen, stimmen Sie unserer ${i?.privacy_policy} und ${i?.terms_of_service} zu.`)
};

const es_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Al continuar utilizando Forest, aceptas nuestra ${i?.privacy_policy} y ${i?.terms_of_service}.`)
};

const fr_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En continuant à utiliser Forest, vous acceptez nos ${i?.privacy_policy} et ${i?.terms_of_service}.`)
};

const it_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Continuando a utilizzare Forest, accetti la nostra ${i?.privacy_policy} e ${i?.terms_of_service}.`)
};

const ja_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`引き続きForestをご利用いただくと、${i?.privacy_policy}および${i?.terms_of_service}に同意したものとみなされます。`)
};

const ko_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Forest를 계속 이용함으로써 귀하는 ${i?.privacy_policy} 및 ${i?.terms_of_service}에 동의합니다.`)
};

const pt_br_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ao continuar usando o Forest, você concorda com nossa ${i?.privacy_policy} e ${i?.terms_of_service}.`)
};

const ru_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Продолжая использовать Forest, вы соглашаетесь с нашими ${i?.privacy_policy} и ${i?.terms_of_service}.`)
};

const th_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เมื่อคุณใช้งาน Forest ต่อไป ถือว่าคุณยอมรับ${i?.privacy_policy}และ${i?.terms_of_service}ของเรา`)
};

const tr_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Forest'ı kullanmaya devam ederek ${i?.["gizlilik_politikası"]} ve ${i?.["hizmet_koşulları"]}nı kabul etmiş olursun.`)
};

const zh_cn_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`继续使用 Forest 即表示你已阅读并同意${i?.privacy_policy}及${i?.terms_of_service}`)
};

const zh_tw_walkturough_landing_footer = /** @type {(inputs: Walkturough_Landing_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`繼續使用 Forest 即表示你已閱讀並同意${i?.privacy_policy}及${i?.terms_of_service}`)
};

/**
* | output |
* | --- |
* | "By continuing to use Forest, you agree to our {privacy_policy} and {terms_of_service}." |
*
* @param {Walkturough_Landing_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_landing_footer = /** @type {((inputs: Walkturough_Landing_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Landing_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_landing_footer(inputs)
	if (locale === "ar") return ar_walkturough_landing_footer(inputs)
	if (locale === "de") return de_walkturough_landing_footer(inputs)
	if (locale === "es") return es_walkturough_landing_footer(inputs)
	if (locale === "fr") return fr_walkturough_landing_footer(inputs)
	if (locale === "it") return it_walkturough_landing_footer(inputs)
	if (locale === "ja") return ja_walkturough_landing_footer(inputs)
	if (locale === "ko") return ko_walkturough_landing_footer(inputs)
	if (locale === "pt_br") return pt_br_walkturough_landing_footer(inputs)
	if (locale === "ru") return ru_walkturough_landing_footer(inputs)
	if (locale === "th") return th_walkturough_landing_footer(inputs)
	if (locale === "tr") return tr_walkturough_landing_footer(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_landing_footer(inputs)
	return zh_tw_walkturough_landing_footer(inputs)
});